import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate";
import {
  EMIT_ACTION_PLAN_TEMPLATE_EVENTS,
  LABELS_ADD_ACTIONPLAN_FORM,
  LABELS_DATATYPE
} from "../../../constants/TemplatePdfConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { PdfTemplateSection } from "@/modules/TemplatePdf/Models/sectionsPdf";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";

Vue.use(Vuetify);
@Component({
  name: "ShowSectionsActionPlan",
  components: {
    ModalTemplate
  }
})
export default class ShowSectionsActionPlan extends Vue {
  @Prop() isModal!: boolean;
  @Prop() sectionList!: PdfTemplateSection[];
  @Prop() isEditing!: boolean;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  LABEL_DATATYPE = LABELS_DATATYPE;
  ADD_LABEL_TITLE = LABELS_ADD_ACTIONPLAN_FORM;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  EDIT_FIELD =
    FORM_TEMP_CONSTANTS.FIELD_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.EDIT_FIELD;
  DELETE_FIELD =
    FORM_TEMP_CONSTANTS.FIELD_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.DELETE_FIELD;
  editSection(section: PdfTemplateSection) {
    this.$emit(EMIT_ACTION_PLAN_TEMPLATE_EVENTS.EDIT_SECTION, section);
  }
  deleteSection(section: PdfTemplateSection) {
    this.$emit(EMIT_ACTION_PLAN_TEMPLATE_EVENTS.REMOVE_SECTION, section);
  }
}
